
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals/[slug]",
      function () {
        return require("private-next-pages/deals/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals/[slug]"])
      });
    }
  